import { openMultistepSection, closeMultistepSections, setEventDisabled } from "./multistepCheckout/multistepFunctions";
import { checkoutDateTimeSelect, selectEventDate } from "./multistepCheckout/selectDateTime";
import { checkoutTicketSelect } from "./multistepCheckout/selectTicket";
import { checkoutServiceSelect } from "./multistepCheckout/selectService";

const productCheckout = () => {
  $(() => {
    // Rimuovi tag <b> dalle slides
    const brs = document.querySelectorAll(".calendar-slide br");
    if (brs.length > 0) {
      brs.forEach((br) => {
        br.remove();
      });

      // Disabilita date eventi non disponibili
      setEventDisabled(".event-closed");
      setEventDisabled(".event-disabled");

      // Init Multistep - Regular Ticket
      const multistepRegularBtn = document.getElementById("openBuyStepOne");
      if (multistepRegularBtn) {
        openBuyStepOne(false);
        multistepRegularBtn.addEventListener("click", () => {
          openBuyStepOne();
        });
      }

      // Init Multistep - Open Ticket
      const multistepOpenBtn = document.getElementById("openBookStepOne");
      if (multistepOpenBtn) {
        multistepOpenBtn.addEventListener("click", () => {
          openBookStepOne();
        });
      }

      // Select Date Slot
      const calendarBtns = document.querySelectorAll(".calendar-btn");
      if (calendarBtns.length > 0) {
        calendarBtns.forEach((calendarBtn) => {
          calendarBtn.addEventListener("click", () => {
            selectEventDate(calendarBtn.id);
          });
        });
      }

      // Select Time Slot
      const timeSlotsBtns = document.querySelectorAll(".time-slot-btn");
      if (timeSlotsBtns.length > 0) {
        timeSlotsBtns.forEach((timeSlotBtn) => {
          timeSlotBtn.addEventListener("click", () => {
            checkoutDateTimeSelect(timeSlotBtn.id, timeSlotBtn.dataset.people);
          });
        });
      }

      // Select Ticket Price
      const priceSection = document.getElementById("event-calendar-ticket-price-section");
      if (priceSection) {
        checkoutTicketSelect(priceSection);
      }

      // Select Services
      const checkoutSection = document.getElementById("final-checkout-section");
      if (checkoutSection) {
        let serviceSelector = checkoutSection.querySelectorAll(".quantity-services");
        if (serviceSelector.length > 0) {
          checkoutServiceSelect(serviceSelector);
        }

        // Popola il form add to cart
        const checkoutBtn = document.getElementById("add-ticket");
        if (checkoutBtn) {
          checkoutBtn.addEventListener("click", () => {
            document.getElementById("my-slot").value = checkoutSection.dataset.selectedSlot;
            document.getElementById("my-quantity").value = checkoutSection.dataset.selectedQuantity;
            document.getElementById("my-services").value = checkoutSection.dataset.selectedServices;
          });
        }
      }
    }
  });
};

export default productCheckout;

/**
 * Multistep - Regular Ticket
 *
 * @param bool scroll
 */

const openBuyStepOne = (scroll = true) => {
  closeMultistepSections();
  const selector = "event-calendar-date-section";
  const section = document.getElementById(selector);
  if (section) {
    setTimeout(() => {
      openMultistepSection("event-calendar-date-section", scroll);
    }, 500);
  }

  const tickets = document.querySelectorAll(".ticket-row");
  if (tickets) {
    tickets.forEach((ticket) => {
      const price = ticket.querySelector(".ticket-price-span");
      const finalPrice = parseFloat(price.getAttribute("data-ticket-price")).toFixed(2);
      price.setAttribute("data-final-price", finalPrice);
      price.innerHTML = finalPrice;
    });
  }

  const regularTicket = document.getElementById("regular-ticket");
  if (regularTicket) {
    regularTicket.style.display = "block";
  }
};

/**
 * Multistep - Open Ticket
 */

const openBookStepOne = () => {
  closeMultistepSections();
  let selector = "event-calendar-ticket-price-section";
  const section = document.getElementById(selector);
  if (section) {
    section.dataset.maxPeople = 10;
    setTimeout(() => {
      openMultistepSection(selector);
    }, 500);

    const tickets = document.querySelectorAll(".ticket-row");
    if (tickets) {
      tickets.forEach((ticket) => {
        ticket.querySelector(".qty-input").max = 10;
        const price = ticket.querySelector(".ticket-price-span");
        const ticketPrice = parseFloat(price.getAttribute("data-ticket-price"));
        const openTicketFee = parseFloat(price.getAttribute("data-open-ticket-fee"));
        const finalPrice = (ticketPrice + openTicketFee).toFixed(2);
        price.setAttribute("data-final-price", finalPrice);
        price.innerHTML = finalPrice;
      });
    }
    const regularTicket = document.getElementById("regular-ticket");
    if (regularTicket) {
      regularTicket.style.display = "none";
    }
    const finalCheckout = document.getElementById("final-checkout-section");
    if (finalCheckout) {
      finalCheckout.dataset.selectedSlot = "open-ticket";
    }
  }
};
